/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AppleBrandLightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABAUlEQVR4nOXUMSuFURjA8VfhkrJYxGI3isGnUETyBYySZLCYfAjL3RXT/QAsZDEYUIpVXKGU5fbTyVveLM77uIv8t9Op/7/znHqK4l+CQezgDuPdlvfiyCeP6Ol2YN0X212VJ3BayltoFL8FwxiqnHcxj35MYCwqXsRFZRxnWMMc9vBUubvBSh35lhirOfIpdALyq6xxoRmQdzCdO57bQOA4S14G3gOBZp3AcyDQqhO4DATeMJIbiHxy4gB9OYFlcU4w+lNgAO1goJ1Wec4rNoOBjdx/aHzbQzlcp9dnBcpI2pQPWWpeMZktr0RmcI4XHGIprQQsYB/35ZadrS3/M3wA8lal7BW1XUoAAAAASUVORK5CYII=)
 */
export const AppleBrandLightIcon = ({
  size = 'md',
  width,
  height,
  color = '#fff',
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19.76 8.82c-.11.09-2.16 1.24-2.16 3.8 0 2.98 2.6 4.03 2.68 4.05 0 .07-.41 1.44-1.37 2.84-.86 1.23-1.75 2.46-3.11 2.46-1.36 0-1.71-.79-3.28-.79-1.53 0-2.08.82-3.32.82-1.24 0-2.11-1.14-3.11-2.54A12.25 12.25 0 0 1 4 12.84c0-3.9 2.53-5.95 5.02-5.95 1.32 0 2.42.86 3.25.86.8 0 2.02-.92 3.53-.92.57 0 2.62.06 3.96 1.99Zm-4.68-3.63a4.47 4.47 0 0 0 1.07-2.79c0-.14-.02-.28-.04-.4a4.47 4.47 0 0 0-2.95 1.52 4.35 4.35 0 0 0-1.1 2.7c0 .16.03.32.04.37l.27.02c.91 0 2.05-.6 2.71-1.42Z"
        className={colorClass}
      />
    </svg>
  );
};
